export default "__VITE_ASSET__bd3b1ac7__"